import _regenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    editValue1: {
      // type: String | Number,
    },
    value: {
      type: String | Number
    },
    dialogOption: {
      type: Object
    },
    /* data: {
      type: Array
    }, */
    tableOption: {
      type: Object
    },
    needData: {
      type: Array
    },
    methodName: {
      type: String
    }
  },
  created: function created() {
    console.log(this.editValue1, 44);
  },
  data: function data() {
    return {
      data: [],
      value1: this.editValue1,
      selectData: "",
      selectDataKey: ""
    };
  },
  methods: {
    //callback
    callback: function callback(fnName, args) {
      console.log(fnName);
      this[fnName] && this[fnName](args);
    },
    //获取数据
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$this$$store$di, code, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.$store.dispatch("".concat(this.methodName), {
                pageSize: 20,
                currentPage: 1
              });
            case 1:
              _yield$this$$store$di = _context.v;
              code = _yield$this$$store$di.code;
              data = _yield$this$$store$di.data;
              if (code == 200) {
                this.data = data.list;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    //输入框点击事件
    inputFocus: function inputFocus() {
      this.dialogOption.dialogVisible = true;
      this.getData();
    },
    //表格勾选事件
    handleSelectionChange: function handleSelectionChange(val) {
      if (val.length > 1) {
        this.$message({
          message: "只能选择一个产品进行操作",
          type: "warning"
        });
        return;
      }
      if (this.needData.length == 1) {
        console.log(val[0][this.needData[0]]);
        this.selectData = val[0][this.needData[0].value];
        this.selectDataKey = val[0][this.needData[0].key];
      }
    },
    //弹框关闭事件
    beforeClose: function beforeClose(val) {
      console.log(val);
      if (val == "dialogCancel") {} else if (val == "dialogConfirm") {
        this.value1 = this.selectData;
        this.$emit("update:value", this.selectDataKey);
      }
      this.dialogOption.dialogVisible = false;
    }
  }
};